import {SdfButton, SdfSpotIllustration} from '@synerg/react-components'
import React from 'react';

function ProjectIllustration ({fullName, partnerName, illusTitle, illusSubtitle, setCreateProjectModal}) {
    return (
        <div className="flex-col mx-24 my-10 items-center sm:mt-16">
            <span className="text-heading-08 font-bold">Welcome {fullName}, from {partnerName}!</span>
            <h1 className="text-4xl font-bold">Projects (0)</h1>

            <div className="flex flex-col items-center mx-24 my-10">
                <SdfSpotIllustration
                    illustrationName="empty-clipboard" size="lg"
                ></SdfSpotIllustration>
                <div className="flex flex-col mt-4 text-center">
                            <span className="text-2xl font-bold leading-xs tracking-xs" style={{ color: "#726c66" }}>
                                {illusTitle || 'You have no projects yet!'}
                            </span>
                    <span className="text-body-02 grey-text mt-2">
                                {illusSubtitle || 'Get started by creating your first project'}
                            </span>
                    <div className="mt-8">
                        <SdfButton action="standard" emphasis="primary" size="sm" variant="contained" onClick={() => {setCreateProjectModal(true)}}>Create new project</SdfButton>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ProjectIllustration;
